import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export function setAuthToken(token) {
  if (token) {
    apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common["Authorization"];
  }
}

const storedToken =
  typeof window !== "undefined" ? localStorage.getItem("ferguson_admin_token") : null;
if (storedToken) setAuthToken(storedToken);

function humanizeField(field) {
  return String(field)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (e && typeof e.msg === "string") {
          const field = Array.isArray(e.loc) ? e.loc[e.loc.length - 1] : null;
          const label = field && typeof field === "string" ? humanizeField(field) : null;
          return label ? `${label}: ${e.msg}` : e.msg;
        }
        return JSON.stringify(e);
      })
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
